import { configureStore } from '@reduxjs/toolkit';
import {
    awardsBlockSlice,
    contactsBlockSlice,
    crewMembersBlockSlice,
    degustationBlockSlice,
    fAQsBlockSlice,
    imagesBlockSlice,
    portfolioBlockSlice,
    navigationBlockSlice,
    placesBlockSlice,
} from 'widgets';
import {
    cateringEventFormatSlice,
    cateringEventPageSlice,
    cateringFormatPageSlice,
    cateringPageSlice,
    culinaryStudioArticlePageSlice,
    culinaryStudioPageSlice,
    deliveryArticlePageSlice,
    deliveryPageSlice,
    homePageSlice,
    outdoorBarsPageSlice,
    outdoorBarArticlePageSlice,
    sweetShopPageSlice,
    sweetShopArticlesPageSlice,
    portfolioEventsPageSlice,
    portfolioEventPageSlice,
    cartPageSlice,
    placesPageSlice,
    placePageSlice,
    sweetShopArticlePageSlice,
    linkPageSlice,
    reviewPageSlice,
    feedbackPageSlice,
    cakeToOrderPageSlice,
} from 'pages';
// eslint-disable-next-line no-restricted-imports
import { headerSlice } from 'widgets/header';
import { appDataProcessSlice } from 'processes';

export const store = configureStore({
    reducer: {
        awardsBlock: awardsBlockSlice.reducer,
        crewMembersBlock: crewMembersBlockSlice.reducer,
        portfolioBlock: portfolioBlockSlice.reducer,
        fAQsBlock: fAQsBlockSlice.reducer,
        degustationBlock: degustationBlockSlice.reducer,
        imagesBlock: imagesBlockSlice.reducer,
        contactsBlock: contactsBlockSlice.reducer,
        navigationBlock: navigationBlockSlice.reducer,
        header: headerSlice.reducer,
        placesBlock: placesBlockSlice.reducer,

        appDataProcess: appDataProcessSlice.reducer,

        homePage: homePageSlice.reducer,
        cateringPage: cateringPageSlice.reducer,
        cateringFormatPage: cateringFormatPageSlice.reducer,
        deliveryPage: deliveryPageSlice.reducer,
        cateringEventFormatPage: cateringEventFormatSlice.reducer,
        cateringEventPage: cateringEventPageSlice.reducer,
        deliveryArticlePage: deliveryArticlePageSlice.reducer,
        culinaryStudioPage: culinaryStudioPageSlice.reducer,
        culinaryStudioArticlePage: culinaryStudioArticlePageSlice.reducer,
        outdoorBarsPage: outdoorBarsPageSlice.reducer,
        outdoorBarArticlePage: outdoorBarArticlePageSlice.reducer,
        sweetShopPage: sweetShopPageSlice.reducer,
        sweetShopArticlesPage: sweetShopArticlesPageSlice.reducer,
        portfolioEventsPage: portfolioEventsPageSlice.reducer,
        portfolioEventPage: portfolioEventPageSlice.reducer,
        cartPage: cartPageSlice.reducer,
        placesPage: placesPageSlice.reducer,
        placePage: placePageSlice.reducer,
        sweetShopArticlePage: sweetShopArticlePageSlice.reducer,
        linkPage: linkPageSlice.reducer,
        reviewPage: reviewPageSlice.reducer,
        feedbackPage: feedbackPageSlice.reducer,
        cakeToOrderPage: cakeToOrderPageSlice.reducer,
    },
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
